import React, { useEffect, useState } from 'react';

interface Props {
  title: React.ReactElement;
  price: React.ReactElement | null;
  totalBalance: number;
  balances: {
    error: number;
    draft: number;
    success: number;
    review: number;
  };
  className?: string;
  colorBackground: string | '#DFE4EB';
}

const TaskProgress = ({
  title,
  price,
  balances,
  totalBalance,
  colorBackground,
  className
}: Props) => {
  const [percentages, setPercentages] = useState<any>({});

  useEffect(() => {
    if (balances) {
      const _percentages: any = {};

      _percentages.draft = (limitTotalBalance(balances.draft) / totalBalance) * 100;
      _percentages.error = (limitTotalBalance(balances.error) / totalBalance) * 100;
      _percentages.success = (limitTotalBalance(balances.success) / totalBalance) * 100;
      _percentages.review = (limitTotalBalance(balances.review) / totalBalance) * 100;

      setPercentages(normalizarPorcentajes(_percentages));
    }
  }, [balances]);

  const normalizarPorcentajes = (json: any) => {
    const { success, ...otrosPorcentajes } = json;
    let empty = 0;
    let totalPorcentajesRestantes: any = Object.values(otrosPorcentajes)
      .reduce((acc: any, val) => acc + val, 0);

    if (success === 100) {
      const porcentajesNormalizados: any = { success };
      for (const key in otrosPorcentajes) {
        porcentajesNormalizados[key] = 0;
      }
      return porcentajesNormalizados;
    }

    if ((success + totalPorcentajesRestantes) < 100)
      empty = 100 - (success + totalPorcentajesRestantes);

    if (totalPorcentajesRestantes === 0) return json;

    if (otrosPorcentajes.draft > 100)
      otrosPorcentajes.draft = otrosPorcentajes.draft - (totalPorcentajesRestantes - otrosPorcentajes.draft);

    if (totalPorcentajesRestantes != 100) totalPorcentajesRestantes = 100;

    let porcentajesNormalizados: any = {};

    for (const key in otrosPorcentajes) {
      porcentajesNormalizados[key] = (otrosPorcentajes[key] / totalPorcentajesRestantes) * 100;
    }
    porcentajesNormalizados.success = success;

    //Priorizar el draft y restar los otros
    function adjustDraft(data: any) {
      let total: any = Object.values(data).reduce((sum: any, value) => sum + value, 0);
      let limit = 100;

      if (total <= limit) return data;

      let priorities = ["error", "review", "success"];
      let excess = total - limit;

      for (let key of priorities) {
        if (data[key] > 0) {
          let reduction = Math.min(data[key], excess);
          data[key] -= reduction;
          excess -= reduction;
          if (excess === 0) break;
        }
      }

      return data;
    }

    return adjustDraft(porcentajesNormalizados);
  };

  const limit100 = (percentage: number) => {
    return percentage > 100 ? 100 : percentage;
  };

  const limitTotalBalance = (value: number) => {
    if (!value)
      return 0;
    return value > totalBalance ? totalBalance : value;
  };

  return (
    <div className={`TaskProgress ${className}`}>
      <div className="flex-btw">
        {title}
        {price}
      </div>
      <div className="bar" style={{ background: `${colorBackground}` }}>
        {!!percentages.success && (
          <div
            className="bar-percentage"
            style={{
              width: `${limit100(percentages.success)}%`,
              background: `var(--green-30)`
            }}
          />
        )}
        {!!percentages.review && (
          <div
            className="bar-percentage"
            style={{
              width: `${limit100(percentages.review)}%`,
              background: `var(--purple-30)`
            }}
          />
        )}
        {/*!!percentages.error && (
          <div
            className="bar-percentage"
            style={{
              width: `${limit100(percentages.error)}%`,
              background: `#C94F4A`
            }}
          />
        )*/}
        {!!percentages.draft && (
          <div
            className="bar-percentage"
            style={{
              width: `${limit100(percentages.draft)}%`,
              background: `#2A2F3C`
            }}
          />
        )}
      </div>
    </div>
  );
};
export default TaskProgress;
